import { ORDERS_ITEMS_ADD } from "./orderActionTypes"

function orderAddItemSuccess(orders){
    return {type:ORDERS_ITEMS_ADD, orders}
}

export function orderAddItems(orders){
    return (dispatch) => dispatch(orderAddItemSuccess(orders))
}